import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import './Launch.css';

export default function LaunchCancel() {
    const [searchParams] = useSearchParams();
    const screenId = searchParams.get('screenId');
    const launchHref = screenId ? `/launch?screenId=${encodeURIComponent(screenId)}` : '/launch';

    return (
        <div className="launch-container">
            <div className="launch-header">
                <div className="launch-logo">INVERT</div>
            </div>
            <div className="launch-content">
                <div className="launch-step">
                    <h1>Payment canceled</h1>
                    <h2>No charge was made</h2>
                    <p className="success-message" style={{ color: '#666' }}>
                        You can return to checkout anytime and try again when you are ready.
                    </p>
                    <Link className="launch-btn primary" style={{ display: 'block', textDecoration: 'none', textAlign: 'center' }} to={launchHref}>
                        Continue launch
                    </Link>
                </div>
            </div>
        </div>
    );
}
